import { Form, Grid, Theme, Viewport } from '@livecontrol/core-ui';
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';
import type { SimpleInterpolation } from 'styled-components';
import styled, { css } from 'styled-components';
import { store } from '../../../../store';
import type { ScheduledEvent } from '../../graphql';

const Separator = styled.div<{ direction: 'bottom' | 'left' | 'right' | 'top' }>`
  ${({ direction }): SimpleInterpolation | undefined =>
    css`
      border-${direction}: 1px solid var(--white40);
    `}
    display: grid;
`;

export const OperatorNotes = ({ scheduledEvent }: { scheduledEvent: ScheduledEvent }): React.ReactElement => {
  const viewport = Theme.useViewport();
  const clientId = scheduledEvent.location?.user?.id;
  
  const userNotes = scheduledEvent.location?.user?.userNotes;
  const noteTypes = ['audio', 'hardware', 'image', 'network', 'technical'];
  
  const productionNotes = noteTypes
    .map(type => `${type.toUpperCase()}:\n${userNotes?.[`${type}_notes` as keyof typeof userNotes]?? ''}`)
    .join('\n\n');

  const ADMIN_DASHBOARD_URI = store(v => v.environment.ADMIN_DASHBOARD_URI);

  return (
    <Form className='mt-24px'>
      <Grid className="gap-16px"
      gridTemplateColumns={
        [Viewport.XL, Viewport.LG].includes(viewport) ? 'repeat(2, 1fr) min-content' : '1fr'
      }
      gridTemplateRows={
        [Viewport.XL, Viewport.LG].includes(viewport) ? '2fr' : undefined
      }
      >
        <Grid>
          <Grid.Item className='d-flex flex-column'>
            <div className='position-relative'>
              <h1 className='text-white font-size-18px'>Support Notes</h1>
            </div>
            <Form.Group
              name='supportNotes'
              label={false}
              error={false}
              className='d-flex flex-column h-100'
              controlProps={{
                as: 'textarea',
                className: 'h-100',
                value: scheduledEvent.location?.user?.support_notes ?? '',
                disabled: true,
                style: { backgroundColor: 'var(--white10)', minHeight: '16rem' }
              }}
            />
          </Grid.Item>

        </Grid>
        <Separator className={cx('pl-lg-16px', !(viewport === Viewport.XL || viewport === Viewport.LG) && 'pt-12px')} direction={
          viewport === Viewport.XL || viewport === Viewport.LG ? 'left' : 'top'
        }>
          <Grid.Item className='d-flex flex-column'>
            <h1 className='text-white font-size-18px'>Production Notes</h1>
            <Form.Group
              name='productionNotes'
              label={false}
              error={false}
              className='d-flex flex-column h-100'
              controlProps={{
                as: 'textarea',
                className: 'h-100',
                value: productionNotes,
                disabled: true,
                style: { backgroundColor: 'var(--white10)', minHeight: '16rem' }
              }}
            />
          </Grid.Item>
        </Separator>
        {clientId && (<a href={`${ADMIN_DASHBOARD_URI}/clients/${clientId}/profile`} target="_blank" className="btn btn-outline-secondary mt-12px" style={{ height: 'min-content' }} rel="noreferrer"><i className="fas fa-edit" /> Edit Notes</a>)}
      </Grid>
    </Form>
  );
};
